'use strict';

module.exports = {
  supportsPopups: require('@braintree/browser-detection/supports-popups')
};
